import { ApolloLink, DefaultContext } from '@apollo/client/core';

export function createSecondarySourceLink(): ApolloLink {
  return new ApolloLink((operation, forward) => {
    const operationContext = operation.getContext();
    const headers = operationContext.headers != null ? operationContext.headers : {};

    if (canUseSecondarySource(operationContext)) {
      headers['x-data-source'] = 'Secondary';
      operation.setContext({ headers });
    }

    return forward != null ? forward(operation) : null;
  });
}

function canUseSecondarySource(context: DefaultContext): context is { useSecondarySource: true } {
  return context?.useSecondarySource === true;
}
